import React from 'react';
const SvgArrowDown: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-9 9-9-9" />
    </svg>
  );
};
export default SvgArrowDown;
